import {GET_ALL_ACTIONS, GET_ALL_ACTIONS_FAIL} from "./actionTypes";

const initialState = {
    actions: [],
    message: "",
    status:0,
    isLoading:true,
}


const actionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_ACTIONS:
            return {
                ...state,
                actions: action.payload.actions,
                message: action.payload.message,
                status: action.payload.status,
                isLoading: false,
            }

        case GET_ALL_ACTIONS_FAIL:
            return  {
                ...state,
                status : action.payload.status,
                message: action.payload.message
            }

        default:
            return {
                ...state
            }
    }
}

export default actionsReducer;